<div class="contenedor-informes-booking">
  <header class="encabezado-pagina">
    <h2>Informes de Booking</h2>
    <p class="texto-secundario">Informes de Ventas, Empleados y Operaciones</p>
  </header>

  <div *ngIf="error" class="alerta alerta-peligro" role="alert">
    {{ error }}
  </div>

  <!-- Panel de Filtros -->
  <div class="panel-filtros">
    <div class="fila-filtros">
      <div class="grupo-filtro">
        <app-field [control]="fromDateControl" [config]="{ label: 'Desde', type: 'date', required: true }">
        </app-field>
      </div>

      <div class="grupo-filtro">
        <app-field [control]="toDateControl" [config]="{ label: 'Hasta', type: 'date', required: true }">
        </app-field>
      </div>

      <div class="grupo-filtro">
        <app-autocomplete [control]="locationControl" [config]="locationAutocompleteConfig">
        </app-autocomplete>
      </div>

      <div class="grupo-filtro">
        <app-autocomplete [control]="conceptControl" [config]="conceptAutocompleteConfig" [disabled]="!locationId">
        </app-autocomplete>
      </div>

      <div class="grupo-filtro">
        <app-autocomplete [control]="staffControl" [config]="staffAutocompleteConfig" [disabled]="!locationId">
        </app-autocomplete>
      </div>
    </div>

    <div class="acciones-filtro">
      <button (click)="loadReports()" class="btn btn-convfact">
        Aplicar Filtros
      </button>
      <button (click)="resetFilters()" class="btn btn-outline-secondary">
        Restablecer
      </button>
      <button (click)="exportToExcel()" class="btn btn-outline-secondary">
        Exportar a Excel
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="cargando">Cargando informes...</div>

  <div *ngIf="!loading && reports">
    <!-- Navegación de Pestañas -->
    <div class="pestanas">
      <button
        [ngClass]="{ 'activa': activeTab === 'sales' }"
        (click)="setActiveTab('sales')"
        class="boton-pestana">
        Informe de Ventas
      </button>
      <button
        [ngClass]="{ 'activa': activeTab === 'employees' }"
        (click)="setActiveTab('employees')"
        class="boton-pestana">
        Informe de Empleados
      </button>
      <button
        [ngClass]="{ 'activa': activeTab === 'operational' }"
        (click)="setActiveTab('operational')"
        class="boton-pestana">
        Informe Operativo
      </button>
    </div>

    <!-- Contenido de Pestañas -->
    <div class="contenido-pestana">
      <app-sales-report
        *ngIf="activeTab === 'sales' && salesReport"
        [data]="salesReport">
      </app-sales-report>

      <app-employees-report
        *ngIf="activeTab === 'employees' && employeesReport"
        [data]="employeesReport">
      </app-employees-report>

      <app-operational-report
        *ngIf="activeTab === 'operational' && operationalReport"
        [data]="operationalReport">
      </app-operational-report>
    </div>
  </div>
</div>

